import { useTheme } from "../../context/ThemeContext";

/**
 * ThemeToggle Component
 * Provides a button to switch between light and dark themes
 */
export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="focus-visible:ring-arti-primary/50 group relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-none border border-slate-300 bg-white text-slate-700 shadow-sm transition-colors hover:border-slate-400 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 dark:border-2 dark:border-slate-700 dark:bg-arti-panel dark:text-slate-300 dark:hover:border-slate-600 dark:hover:bg-arti-background"
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      {/* Sun icon - visible in dark mode */}
      <svg
        className="absolute h-4 w-4 rotate-90 scale-0 text-gray-700 transition-all dark:rotate-0 dark:scale-100 dark:text-amber-300"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
        />
      </svg>

      {/* Moon icon - visible in light mode */}
      <svg
        className="absolute h-4 w-4 rotate-0 scale-100 text-gray-700 transition-all dark:-rotate-90 dark:scale-0 dark:text-slate-300"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
        />
      </svg>
    </button>
  );
}
